import { defineStore } from 'pinia'

import { VALID_FIAS_WITHOUT_STREET } from '@/constants/statesOfAddressSystem'

import { StoreId } from '@/store'
import { DEFAULT_STATE_ADDRESS_SYSTEM } from '@/store/addressSystem/address-system.constants'
import type {
  AddressSystemState,
  SelectedAddress,
} from '@/store/addressSystem/address-system.types'
import { getDefaultDeliveryAddress } from '@/store/addressSystem/address-system.utils'
import type { DeliveryDataAddress } from '@/store/delivery/delivery.types'
import { PlacesSearch } from '@/store/delivery/delivery.types'
import { useUserStore } from '@/store/user/user'

import { SetDeliveryMethodPayload } from '@/api/modules/basket/types'
import { StateGeoAddress } from '@/types/mapServices'

import { storage } from '@/services/storage'
import { STORAGE_KEY } from '@/services/storage/constants'

export const useAddressSystemStore = defineStore(StoreId.ADDRESS_SYSTEM, {
  state: (): AddressSystemState => DEFAULT_STATE_ADDRESS_SYSTEM,
  actions: {
    setVisibleAddressSystemDialog(state: boolean) {
      this.$state.isVisibleAddressSystemDialog = state
    },
    setSelectedAddress(selectedAddress: SelectedAddress) {
      this.$state.selectedAddress = selectedAddress
    },
    setLoadingWidget(loading: boolean) {
      this.$state.isLoadingWidget = loading
    },
    changeDeliveryWidget(payload: SetDeliveryMethodPayload) {
      const { isAuthenticated } = useUserStore()

      this.$state.delivery.widget = { ...payload }

      if (isAuthenticated) return

      storage.set(STORAGE_KEY.addressSystem.deliveryWidget, payload)
    },
    changeDeliveryBasket(payload: SetDeliveryMethodPayload) {
      this.$state.delivery.basket = payload
    },
    setDeliveryAddress(deliveryDataAddress: DeliveryDataAddress) {
      this.deliveryAddress = deliveryDataAddress
    },
    setDeliveryAddressState(state: StateGeoAddress) {
      this.deliveryAddress.state = state
    },
    resetDeliveryAddress(place: PlacesSearch | null = null) {
      this.deliveryAddress = getDefaultDeliveryAddress(place)
    },
  },
  getters: {
    deliveryBasket: ({ delivery }) => delivery.basket,
    deliveryWidget: ({ delivery }) => delivery.widget,
    isNewDeliveryAddressDisabled: ({ deliveryAddress }) => {
      const address = deliveryAddress?.address?.address
      const isMapAddress = deliveryAddress?.address.place === PlacesSearch.MAP
      let isStreetValid = !!address?.street_with_type

      if (
        (address?.fias_level &&
          VALID_FIAS_WITHOUT_STREET.includes(address.fias_level)) ||
        isMapAddress
      ) {
        // Если есть нужный fias_level, то проверяем только house
        isStreetValid = true
      }

      // Если текущее состояние ДО = выбор нового адреса и метод доставки курьер, то проверяем по выбранному адресу
      return !isStreetValid || !address?.house
    },
  },
})
